// import RulePack from './RulePack';

export default {
  priority: 11,
  path: 'packet',
  permissions: ['RequestsMenu/RequestPattern/PatternDefinitionMenu'],
  // component: RulePack,
  component: load(() => import(/* webpackChunkName: "Request-pattern-RulePack" */ './RulePack')),
  name: app.translate('routes.home.requests.Definition'),
  icon: 'content-paste',
  drawer: true,
};


